<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>서비스 신청 및 조회</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>조회/변경/취소</p>
            </div>
        </div>

        <div id="as-search-section" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">1. AS 접수 조회</p>
            <div style="width:100%; height: 1px; background: gray"></div>
            <p style="font-size: 20px">
                조회를 위해 등록때 사용하신 전화번호를 입력해주세요. ( '-' 없이 숫자만 입력하세요)
            </p>
            <search-bar
                :size="100"
                :text="asPhoneNumber"
                :disabled="userProfile != null"
                v-on:onSearch="searchAsPhoneNumber"
            ></search-bar>
        </div>

        <div id="afterservice" class="screen-width">
            <div class="row" style="gap: 14px; margin-bottom: 16px">
                <p
                    style="font-size: 28px; font-weight: bold; color: #00a7e7"
                ></p>
                <p style="font-size: 28px; font-weight: bold">조회 결과</p>
            </div>
            <div id="afterservice-list">
                <submit-item
                    v-for="(as, index) in afterservices"
                    :key="index"
                    :title="as.detail_issue"
                    :category="as.defect_type"
                    :date="formatKoreanDate(as.createdAt)"
                    :classId="as.id"
                    :status="as.status"
                    :phone_number="asPhoneNumber"
                    :userId="userProfile != null? userProfile.id : null"
                    v-on:checked="selectClass"
                >
                </submit-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentAsPage"
                :totalPages="totalAsPages"
                v-on:update="loadAsPageData"
            ></custom-pagination>
        </div>

        <div class="screen-width" style="margin-top: 32px; margin-bottom: 80px"></div>

        <div id="eductaion-search-section" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">2. 교육 신청 조회</p>
            <div style="width:100%; height: 1px; background: gray"></div>
            <p style="font-size: 20px">
                조회를 위해 등록때 사용하신 전화번호를 입력해주세요. ( '-' 없이 숫자만 입력하세요)
            </p> 
            <search-bar
                :size="100"
                :text="lecturePhoneNumber"
                :disabled="userProfile != null"
                v-on:onSearch="searchLecturePhoneNumber"
            ></search-bar>
        </div>

        <div id="education" class="screen-width">
            <div class="row" style="gap: 14px; margin-bottom: 16px">
                <p
                    style="font-size: 28px; font-weight: bold; color: #00a7e7"
                ></p>
                <p style="font-size: 28px; font-weight: bold">조회 결과</p>
            </div>
            <div id="education-list">
                <apply-lecture-item
                    v-for="(lecture, index) in lecture"
                    :key="index"
                    :title="lecture.title"
                    :category="lecture.category"
                    :date="lecture.date"
                    :applyId="lecture.apply[0].id"
                    :lectureId="lecture.id"
                    :phone_number="lecturePhoneNumber"
                    :userId="userProfile != null? userProfile.id : null"
                >
                </apply-lecture-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentLecturePage"
                :totalPages="totalLecturePages"
                v-on:update="loadLecturePageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import SubmitItem from "@/components/SubmitItem.vue";
import ApplyLectureItem from "@/components/ApplyLectureItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import DatePicker from "primevue/datepicker";
import PinModal from "@/components/PinModal.vue";

export default {
    props: {
        category: {
            type: String,
            default: "GPS플로터",
        },
    },
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        SubmitItem,
        CustomPagination,
        DatePicker,
        ApplyLectureItem,
        PinModal,
    },
    setup() {
        const store = useStore();
        const user_id = ref(null);

        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        onMounted(async () => {
            store.commit("setAfterserviceList", []);
            store.commit("setApplyLectureList", []);
            try {
                const userProfile = await store.dispatch("getUserProfile");
                asPhoneNumber.value = userProfile.phone_number;
                lecturePhoneNumber.value = userProfile.phone_number;
                user_id.value = userProfile.id;
                getAfterserviceList();
                getApplyLectureList();
            } catch (err) {
                console.log(err);
            }
        });
        const asPhoneNumber = ref("");

        const lecturePhoneNumber = ref("");

        const currentAsPage = ref(1);
        const totalAsPages = computed(() => {
            return Math.ceil(store.getters.getAfterserviceTotalCount / 10);
        });


        const currentLecturePage = ref(1);
        const totalLecturePages = computed(() => {
            return Math.ceil(store.getters.getApplyLectureTotalCount / 10);
        });


        const loadAsPageData = (page) => {
            currentAsPage.value = page;
            getAfterserviceList();
        };

        const loadLecturePageData = (page) => {
            currentLecturePage.value = page;
            getApplyLectureList();
        };

        const afterservices = computed(() => {
            return store.getters.getAfterserviceList;
        });

        const lecture = computed(() => {
            return store.getters.getApplyLectureList;
        });

        const searchLecturePhoneNumber = (phone_number) => {
            lecturePhoneNumber.value = phone_number;
            currentLecturePage.value = 1;
            getApplyLectureList();
        };

        const getAfterserviceList = () => {
            store.dispatch("getAfterserviceList", {
                userId : user_id.value,
                phone_number: asPhoneNumber.value,
                page: currentAsPage.value,
                take: 10,
            });
        }

        const getApplyLectureList = () => {
            store.dispatch("getApplyLectureList", {
                userId : user_id.value,
                phone_number: lecturePhoneNumber.value,
                page: currentLecturePage.value,
                take: 10,
            });
        }

        const searchAsPhoneNumber = (phone_number) => {
            asPhoneNumber.value = phone_number;
            currentAsPage.value = 1;
            getAfterserviceList();            
        };

        const userProfile = computed(() => {
            return store.getters.getUserProfile;
        });

        return {
            asPhoneNumber,lecturePhoneNumber,
            currentAsPage,
            totalAsPages,
            currentLecturePage,
            totalLecturePages,
            loadAsPageData,
            loadLecturePageData,
            afterservices,
            lecture,
            searchAsPhoneNumber,
            userProfile,
            formatKoreanDate,
            searchLecturePhoneNumber,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#as-search-section {
    padding: 40px 0px;
    gap: 24px;
}

#eductaion-search-section {
    padding: 40px 0px;
    gap: 24px;
}

textarea {
    padding: 10px;
    resize: none;
    border: none;
}
textarea:focus {
    outline: none !important;
}
input:focus {
    outline: none !important;
}

.p-datepicker.p-inputtext:enabled:focus {
    border-color: black !important;
}

.p-datepicker /deep/ .p-inputtext:enabled:focus {
    height: 56px; /* 예시: 높이 변경 */
    border: 1px solid rgb(162, 162, 162); /* 예시: 테두리 색상 변경 */
    outline: none;
}

#afterservice {
    padding: 32px 0px;
}

#afterservice-list {
    width: 100%;
    border-top: 1px solid black;
}
#education {
    padding: 32px 0px;
}

#education-list {
    width: 100%;
    border-top: 1px solid black;
}
</style>
